import PropTypes from "prop-types";
import Footer from "../../components/Footer/Footer";
import AboutNavbar from "../../components/Navbar/AboutNavbar";

const AboutLayout = ({ children }) => {
  return (
    <>
      <AboutNavbar />
      <main className="about-layout-main-box">{children}</main>
      <Footer />
    </>
  );
};
AboutLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
export default AboutLayout;
